import { useMemo } from 'react';

import { getDesignTokens, DesignTokenSet } from '~/client/components/base/core';
import { useAccentPalette } from '~/client/contexts/accent-context';
import { useThemeMode } from '~/client/contexts/theme-context';

/**
 * Returns theme-aware design tokens for the current theme mode and accent palette.
 * Use in components that need token values outside MUI theme (e.g. styled-components, custom CSS).
 */
export function useDesignTokens(): DesignTokenSet {
  const { effectiveMode } = useThemeMode();
  const { accentPalette } = useAccentPalette();
  return useMemo(
    () => getDesignTokens(effectiveMode, accentPalette),
    [effectiveMode, accentPalette]
  );
}
